const stage = process.env.REACT_APP_ENV || "production";

let environment;
switch (stage) {
  case "production":
    environment = {
      STAGE: stage,
      SENTRY_DSN: "",
      V2_PRODUCTS: ["capitalLoan", "invoiceFinancing"] as string[],
      GA_MEASUREMENT_ID: "G-R53WNMM7SD",
      API: {
        TIMEOUT: 60000,
        HOST: "",
      },
      URL: "https://www.pohondana.id",
      API_URL: "https://apiv2.pohondana.id",
      POHON_DANA_URL: "https://app.pohondana.id",
      USER_PORTAL: "https://user.pohondana.id",
      EMPLOYEE_LOAN: "https://employee.pohondana.id",
    };
    break;

  case "staging":
    environment = {
      STAGE: stage,
      SENTRY_DSN: "",
      V2_PRODUCTS: ["capitalLoan", "invoiceFinancing"] as string[],
      GA_MEASUREMENT_ID: "",
      API: {
        TIMEOUT: 60000,
        HOST: "",
      },
      URL: "",
      API_URL: "https://api.staging.pohondana.co.id",
      POHON_DANA_URL: "https://staging.pohondana.co.id",
      USER_PORTAL: "https://user.pohondana.id",
      EMPLOYEE_LOAN: "https://employee.pohondana.id",
    };
    break;

  case "test":
  case "development":
  default:
    environment = {
      STAGE: stage,
      SENTRY_DSN: "",
      V2_PRODUCTS: ["capitalLoan", "invoiceFinancing"] as string[],
      GA_MEASUREMENT_ID: "",
      API: {
        TIMEOUT: 60000,
        HOST: "",
      },
      URL: "http://localhost:3000",
      API_URL: "https://api-dev.pohondana.id",
      POHON_DANA_URL: "https://dev.pohondana.id",
      USER_PORTAL: "https://user.pohondana.id",
      EMPLOYEE_LOAN: "https://employee.pohondana.id",
    };
    break;
}

export const ENV = environment;
